import { EmptyState } from "../components/EmptyState";

/** An area the plan has reached but the work packages have not. Says so plainly. */
export function PlaceholderPage({
  title,
  description,
  workPackage,
}: {
  title: string;
  description: string;
  workPackage: string;
}) {
  return (
    <EmptyState
      title={title}
      description={description}
      action={
        <p className="nb-num text-overline uppercase tracking-[0.09em] text-muted">
          Byggs i {workPackage}
        </p>
      }
    />
  );
}
